import React from 'react';
import Box from '../../../../Box/Box';
import HStack from '../../../../HStack/HStack';
import { useSiteKit } from '../../SiteKitContext/SiteKitContext';
import { SiteKitLogoAnchor } from '../SiteKitLogoAnchor/SiteKitLogoAnchor';
import { CartaLogo, CartaWordmark, CartaXLogo } from '../../../assets/Logos';
import { SiteKitIconButton } from '../../SiteKitIcon/SiteKitIconButton/SiteKitIconButton';

interface SiteKitControlsProps {
  logo: 'carta' | 'carta-wordmark' | 'ccmx';
}
const SiteKitControls = ({ logo }: SiteKitControlsProps) => {
  const { isMobileOrTablet, setSidebarOpen } = useSiteKit();
  return (
    <Box left="gutter" vertical="medium" top="gutter">
      <HStack alignY="center" align="distributed" spacing="none">
        <SiteKitLogoAnchor aria-label={logo === 'ccmx' ? 'CartaX' : 'Carta'}>
          {logo === 'carta' && <CartaLogo />}
          {logo === 'carta-wordmark' && <CartaWordmark />}
          {logo === 'ccmx' && <CartaXLogo />}
        </SiteKitLogoAnchor>
        <SiteKitIconButton
          data-testid="menu-toggle-button"
          icon={isMobileOrTablet ? 'times' : 'angle-double-left'}
          label={isMobileOrTablet ? 'Close' : 'Collapse'}
          theme="light"
          onClick={() => setSidebarOpen(false)}
        />
      </HStack>
    </Box>
  );
};

SiteKitControls.displayName = 'SiteKit.Sidebar.Controls';

export { SiteKitControls, SiteKitControlsProps };
